import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "./i18n";
import ScrollToTop from "./components/ScrollToTop";

// Eagerly load Home (first paint) — lazy-load everything else for snappier navigation
import Home from "./pages/Home";
const Programs = lazy(() => import("./pages/Programs"));
const GraduateDirectory = lazy(() => import("./pages/GraduateDirectory"));
const GraduateRegistration = lazy(() => import("./pages/GraduateRegistration"));
const News = lazy(() => import("./pages/News"));
const Events = lazy(() => import("./pages/Events"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const Contact = lazy(() => import("./pages/Contact"));
const MathClub = lazy(() => import("./pages/MathClub"));
const Nukhb = lazy(() => import("./pages/Nukhb"));
const KhutaSadaThankYou = lazy(() => import("./pages/KhutaSadaThankYou"));
const KhutaSadaReport = lazy(() => import("./pages/KhutaSadaReport"));
const KhutaSadaProgram = lazy(() => import("./pages/KhutaSadaProgram"));
const CertificatePage = lazy(() => import("./pages/CertificatePage"));

const PageLoader = () => (
  <div
    className="min-h-screen flex items-center justify-center"
    style={{ background: "linear-gradient(135deg,#0B132B,#1E3A8A)" }}
    data-testid="page-loader"
  >
    <div className="w-12 h-12 border-4 border-[#D4AF37]/30 border-t-[#D4AF37] rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/programs/math-club" element={<MathClub />} />
            <Route path="/programs/nukhb" element={<Nukhb />} />
            <Route path="/directory" element={<GraduateDirectory />} />
            <Route path="/register" element={<GraduateRegistration />} />
            <Route path="/news" element={<News />} />
            <Route path="/events" element={<Events />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/khuta-sada" element={<KhutaSadaProgram />} />
            <Route path="/khuta-sada/thank-you" element={<KhutaSadaThankYou />} />
            <Route path="/admin/khuta-sada/report" element={<KhutaSadaReport />} />
            <Route path="/certificate/:token" element={<CertificatePage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
